export const StartupDashboardSkeleton = () => {
  return (
    <div className="container mx-auto py-8 px-4 animate-pulse">
      <div className="h-8 bg-gray-700/20 rounded w-1/4 mb-6" />
      <div className="grid gap-6">
        <div className="h-48 bg-gray-700/20 rounded" />
        <div className="h-48 bg-gray-700/20 rounded" />
      </div>
    </div>
  );
};